import PublicLayout from "@/components/layout/PublicLayout";
import Hero from "@/components/sections/Hero";
import StatsBar from "@/components/sections/StatsBar";
import HowItWorks from "@/components/sections/HowItWorks";
import ReportPreview from "@/components/sections/ReportPreview";
import Audiences from "@/components/sections/Audiences";
import Trust from "@/components/sections/Trust";
import Testimonials from "@/components/sections/Testimonials";
import PricingSection from "@/components/sections/PricingSection";
import FaqPreview from "@/components/sections/FaqPreview";
import Seo, { organizationSchema, serviceSchema } from "@/components/Seo";

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [organizationSchema, serviceSchema],
  };
  return (
    <PublicLayout>
      <Seo
        title="OfferteExpert — Weet wat eerlijk is. Betaal wat eerlijk is."
        description="Upload je offerte en weet binnen 60 seconden of je te veel betaalt. Slimme offerte-analyse voor België en Nederland. Vanaf €4,99 per analyse."
        jsonLd={jsonLd}
      />
      <Hero />
      <StatsBar />
      <HowItWorks />
      <ReportPreview />
      <Audiences />
      <Trust />
      <Testimonials />
      <PricingSection />
      <FaqPreview />
    </PublicLayout>
  );
}
